import { VegaButton, VegaFont, VegaPageNotification } from '@globalpayments/vega-react';

import DetailsModal from '../../../components/detailsModal';
import { UserSummary } from '../../../types/users';

interface DeleteUserDialogProps {
  error?: Error | null;
  isPending: boolean;
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  user?: UserSummary;
}

/** Confirms permanent removal of an application user. */
const DeleteUserDialog = ({ error, isPending, onClose, onSubmit, open, user }: DeleteUserDialogProps) => (
  <DetailsModal
    backdrop="static"
    footerActions={
      <VegaButton
        disabled={!user || isPending}
        label={isPending ? 'Deleting user' : 'Delete user'}
        onVegaClick={onSubmit}
        variant="secondary"
      />
    }
    modalTitle="Delete user"
    onClose={onClose}
    open={open}>
    {error && (
      <VegaPageNotification
        duration={0}
        message={error.message}
        notificationTitle="Delete failed"
        type="error"
      />
    )}
    <VegaFont as="p">
      Permanently delete {user?.displayName ?? user?.email}? Their application access and role assignments will be
      removed.
    </VegaFont>
  </DetailsModal>
);

export default DeleteUserDialog;
